import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 sm:flex-row" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex flex-col gap-y-4 sm:flex-row" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex-1" }

import { reformatDateString } from '@/helpers/dates'
import { formatToFinnishCurrency } from '@/helpers/formatters'
import { useI18n } from 'vue-i18n'

interface Props {
  /** The payslip input data */
  payslipInput: PayslipInput
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipInputTaxCardSummary',
  props: {
    payslipInput: {}
  },
  setup(__props: any) {



const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('salary.labels.withholding_percent')), 1),
        _createElementVNode("p", null, _toDisplayString(__props.payslipInput.withholding_percent), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('salary.labels.additional_withholding_percent')), 1),
        _createElementVNode("p", null, _toDisplayString(__props.payslipInput.additional_withholding_percent), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('salary.labels.income_limit')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(formatToFinnishCurrency)(__props.payslipInput.income_limit ?? 0)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('salary.labels.income_tax_card_date')), 1),
        _createElementVNode("p", null, _toDisplayString(_unref(reformatDateString)(__props.payslipInput.income_tax_card_date ?? '')), 1)
      ])
    ])
  ], 64))
}
}

})